import { TransferAPI } from '../services/api/transfer';

import { ActionHelper } from '../../core-bundle/store/actions-generator';

import Action from '@app/action';

export const ActionTypes = ActionHelper.generateTypes(['VERIFY_PASSWORD']);

export const TransferActions = ActionHelper.generateActions({
  verifyPassword,
});

function verifyPassword(transferId, secret, recipient, password) {
  return async (dispatch) => {
    try {
      const fetchedTransfer = await TransferAPI.fetchTransfer(
        transferId,
        secret,
        recipient,
        password,
        false
      );

      dispatch(Action.Transfer.verifiedPassword(password));
      dispatch(Action.Transfer.buildTransfer(fetchedTransfer, password));
      dispatch(Action.Notification.clearTransfer());
    } catch (error) {
      dispatch(Action.Notification.pushTransfer({ text: 'InvalidPassword' }));
    }
  };
}
